import onQuickOptionToggle from 'owa-options-actions/lib/onQuickOptionToggle';
import { orchestrator } from 'satcheljs';
import { logUsage } from 'owa-analytics';
var QUICK_SETTINGS_TOGGLE_USAGE_KEY = 'quickSettingsToggle';
export default orchestrator(onQuickOptionToggle, function (actionMessage) {
    var option = actionMessage.option, isToggledOn = actionMessage.isToggledOn;
    logUsage(QUICK_SETTINGS_TOGGLE_USAGE_KEY, {
        optionKey: option.key,
        isToggledOn: "" + isToggledOn,
    });
    var onToggle = option.quickOptionSettings.rendering.onToggle;
    if (onToggle) {
        onToggle(isToggledOn);
    }
});
//# sourceMappingURL=toggleQuickOption.js.map